export const APP_VERSION = 'v1.0.0';
export const APP_NAME = 'Forge PDF'; 